module.exports = __webpack_public_path__ + "media/images/lane/collapse-open-a964cc2cbf7ffe75255b5fce811c32ac.png";